import { Alert, AlertProps } from "@mui/material";

export default function Notice({
  message,
  onClose,
  ...props
}: AlertProps & { message: string; onClose?: () => void }): JSX.Element {
  return (
    <Alert severity="info" onClose={onClose} {...props} sx={{ mb: 2 }}>
      {message}
    </Alert>
  );
}
